import cardBg from "../../assets/creditCardBg.jpg";

function PaymentMethodCardSelection({
  loadingCards,
  cards,
  setSelectedCard,
  selectedCard,
}) {
  return (
    <div className="w-full mt-4">
      <div className="flex overflow-scroll max-w-2xl gap-3 scroll-hide">
        {loadingCards ? (
          <>
            {[...Array(3)].map((_, index) => (
              <div
                key={index}
                className="w-[300px] flex shrink-0 p-2 rounded-lg"
              >
                <div className="w-full h-[150px] rounded-md animate-pulse bg-gray-300 flex shrink-0"></div>
              </div>
            ))}
          </>
        ) : (
          <>
            {cards?.map((card, cardIndex) => {
              let isSelected = card?._id === selectedCard;
              return (
                <button
                  className={`flex shrink-0 w-[300px] p-2 rounded-lg border ${
                    isSelected ? "border-primary1" : "border-transparent"
                  }`}
                  key={cardIndex}
                  onClick={() => {
                    setSelectedCard(card?._id);
                  }}
                >
                  <div
                    className="w-full h-[150px] rounded-lg p-2 flex flex-col justify-between"
                    style={{
                      backgroundImage: `url(${cardBg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <div className="w-full flex justify-end">
                      <img
                        src="/IconVisa.svg"
                        alt=""
                        className="h-10 object-contain"
                      />
                    </div>
                    <div className="w-full flex gap-1 items-center">
                      {[...Array(3)].map((_, topIndex) => (
                        <div className="gap-1 flex" key={topIndex}>
                          {[...Array(4)].map((_, idx) => (
                            <span key={idx} className="ml-0 first:ml-2">
                              *
                            </span>
                          ))}
                        </div>
                      ))}
                      <div className="flex gap-1 mb-1 ml-2">
                        {card?.last4?.split("").map((item, charIndex) => (
                          <small key={charIndex}>{item}</small>
                        ))}
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <small>{card?.bank}</small>
                      <small>
                        {card?.exp_month}/{card.exp_year?.slice(-2)}
                      </small>
                    </div>
                  </div>
                  {/* <img src={cardBg} alt="" /> */}
                </button>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

export default PaymentMethodCardSelection;
